import React, {useContext, useEffect, useRef, useState} from 'react';
import {withRouter} from 'react-router-dom';

import {AppContext} from '../../AppModule/Context';
import {withExpertHomeContext} from '../../screens/ExpertHome/ExpertHomeContextProvider';

import InfoComponentV2 from '../common/genericComponents/redesign/infoComponentV2/infoComponentV2';
import MultiStateButton from '../common/genericComponents/redesign/multiStateButton/multiStateButton';
import NotificationComponent from '../common/genericComponents/notificationComponent';
import SessionCostAndCurrencyComponent from '../expertDashboardModule/expertSettingsComponent/components/sessionCostAndCurrencyComponent/sessionCostAndCurrencyComponent';

import expertHomeService from '../../services/expertHomeService';
import utilsService from '../../services/utilsService';

import './paymentRequestComponent.css';

const PaymentRequestInitiatorRender = ({
  expertHomeContext = {},
  history = {},
  parentRef,
  PAYMENT_STATUS,
}) => {
  const context = useContext(AppContext);

  const paymentRequestContainerRef = useRef(null);
  const [paymentStatusText, setPaymentStatusText] = useState('');
  const [paypalEmail, setPaypalEmail] = useState(null);
  const [
    isPaypalAndStripeConfiguredProperly,
    setIsPaypalAndStripeConfiguredProperly,
  ] = useState(null);
  const [showNotificationPopUp, setShowNotificationPopUp] = useState(false);
  const [notificationPopUpData, setNotificationPopUpData] = useState({});

  useEffect(() => {
    const mentorId = parentRef.props?.chatRoomDto?.mentorId;
    if (mentorId) {
      const paypalEmail =
        expertHomeService.getWidgetNameExMentorDtoUsingMentorId(
          expertHomeContext.widgetDtos,
          mentorId,
        )?.extendedMentorDto?.mentorDto?.paypalEmail;
      setPaypalEmail(paypalEmail);
    } else {
      setPaypalEmail(null);
    }
  }, [parentRef.props.chatRoomDto?.mentorId]);

  useEffect(() => {
    window.addEventListener('click', handleOutsideEvent);
    return () => {
      window.removeEventListener('click', handleOutsideEvent);
    };
  }, []);

  const handleOutsideEvent = (e) => {
    const classOfElement = e.target.getAttribute('class');
    const classNamesToExclude = [
      'et-share-payment-icon',
      'et-share-payment-span',
      'et-autocomplete-dropdown-overlay',
      'et-autocomplete-dropdown-listItem',
    ];
    if (
      !paymentRequestContainerRef.current.contains(e.target) &&
      classOfElement &&
      !classNamesToExclude.some((className) =>
        classOfElement.includes(className),
      )
    ) {
      parentRef.props.closePaymentPopup();
    }
  };

  useEffect(() => {
    let paymentStatusText = '';
    switch (parentRef.state.paymentStatus) {
      case PAYMENT_STATUS.INIT:
        paymentStatusText = '';
        break;
      case PAYMENT_STATUS.REQUEST_SENT:
        paymentStatusText = 'Payment request sent';
        break;
      case PAYMENT_STATUS.REQUEST_RECEIVED_ON_PEER:
        paymentStatusText = 'Payment request got to destination';
        break;
      case PAYMENT_STATUS.PEER_ACCEPTED_AND_STARTED_PAYMENT_FLOW:
        paymentStatusText = 'Peer accepted and started payment flow';
        break;
      case PAYMENT_STATUS.SUCCESS:
        paymentStatusText = 'Payment has succeeded';
        break;
      default:
        paymentStatusText = 'Payment failed. Retry?';
    }
    setPaymentStatusText(paymentStatusText);
  }, [parentRef.state.paymentStatus]);

  const showErrorNotificationPopuUp = () => {
    setShowNotificationPopUp(true);
    setNotificationPopUpData({
      acceptBtnTxt: 'Set payment gateways',
      acceptBtnFunc: () => {
        const ROUTES = utilsService.getRoutesEnumByImpersonationMode(
          context.isImpersonatedModeActive,
        );
        history.push(ROUTES.EXPERT_SETTINGS, {
          navUrl: 'widgetSetup/setUpInstallation/paymentGateways',
        });
      },
      notificationTxt:
        'Please make sure your payment gateways are connected and support the selected currency',
    });
  };

  const closeNotificationPopUp = () => {
    setShowNotificationPopUp(false);
    setNotificationPopUpData({});
  };

  return (
    <>
      {showNotificationPopUp && (
        <NotificationComponent
          acceptBtnTxt={notificationPopUpData.acceptBtnTxt}
          notificationTxt={notificationPopUpData.notificationTxt}
          closeBtnTxt={'Close'}
          acceptBtnFunc={notificationPopUpData.acceptBtnFunc}
          closeBtnFunc={closeNotificationPopUp}
        />
      )}
      <div
        ref={paymentRequestContainerRef}
        className="et-payment-request-initiator-container">
        <div className="et-pri-payment-request-txt"> Payment request</div>
        <SessionCostAndCurrencyComponent
          paypalEmail={paypalEmail}
          sessionCost={parentRef.state?.sessionDto?.sessionCost}
          sessionCostToolTipTxt={
            'This is the amount you received and it excludes the transaction fees'
          }
          sessionCurrency={parentRef.state?.sessionDto?.sessionCurrency}
          sessionTemplateId={parentRef.state?.sessionDto?.sessionTemplateId}
          setIsFetchingConfiguration={parentRef.setIsFetchingConfiguration}
          onSessionCostChanged={(value) => {
            const event = {
              target: {id: 'paymentCost', value},
            };
            parentRef.handlePaymentCost(event);
          }}
          onSessionCostChangeFailed={() => {
            showErrorNotificationPopuUp();
          }}
          onSessionCurrencyChanged={parentRef.handleCurrencyChange}
          onSessionCurrencyChangeFailed={() => {
            showErrorNotificationPopuUp();
          }}
          setIsPaypalAndStripeConfiguredProperly={
            setIsPaypalAndStripeConfiguredProperly
          }
        />
        {paymentStatusText.length > 0 && (
          <div className="et-pri-info-component-wrap">
            <InfoComponentV2 subTitleTxt={paymentStatusText} />
          </div>
        )}
        <div className="et-pri-payment-btns-wrap">
          <div className="et-pri-payment-btn">
            <MultiStateButton
              btnTxt="Close"
              onClick={parentRef.props.closePaymentPopup}
            />
          </div>
          <div
            className={`et-pri-payment-btn ${
              parentRef.state.paymentStatus === PAYMENT_STATUS.PEER_REJECTED
                ? 'et-pri-request-again-btn'
                : ''
            }`}>
            <MultiStateButton
              isPrimaryBtn
              isDisabled={isPaypalAndStripeConfiguredProperly === null}
              showSpinner={parentRef.state.isFetchingConfiguration}
              btnTxt={
                parentRef.state.paymentStatus === PAYMENT_STATUS.PEER_REJECTED
                  ? 'Request again'
                  : 'Request'
              }
              onClick={() => {
                if (isPaypalAndStripeConfiguredProperly) {
                  parentRef.handleSubmit();
                } else {
                  showErrorNotificationPopuUp();
                }
              }}
            />
          </div>
        </div>
        <div className="et-pri-bottom-arrow" />
      </div>
    </>
  );
};

export default withRouter(withExpertHomeContext(PaymentRequestInitiatorRender));
